export const filterActivitiesForUser = (activities = [], userId) => {
  const uid = Number(userId);

  return activities.filter((activity) => {
    try {
      const assigned = JSON.parse(activity.assigned_users || "[]");
      return assigned.some((u) => Number(u.id) === uid);
    } catch {
      return false;
    }
  });
};

export const filterEventsForUser = (eventsArray = [], userId, role) => {
  if (role !== "user") return eventsArray;

  return eventsArray
    .map((event) => {
      const filteredActivities = filterActivitiesForUser(
        event.activities,
        userId
      );

      if (filteredActivities && filteredActivities.length > 0) {
        return { ...event, activities: filteredActivities };
      }
      return null;
    })
    .filter(Boolean);
};
